module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1025-594bfd66802d44ef7ddba9be52e30ed0.png";